var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-strength-meter",class:{ mounted: _vm.mounted }},[_c('div',{staticClass:"password-strength-meter--fill",attrs:{"data-score":_vm.score}})])}
var staticRenderFns = []

export { render, staticRenderFns }